
import Vue from 'vue'

const Transformer = ({has_catalog_and_commercial_agreements: catalog, has_sinister_number: number, has_sinister_date: date, has_inbursa_chaining_and_reporting: inbursa}) => {
  return [
    {
      name: "Acuerdos comerciales y catálogo",
      checked: catalog === 1,
      reject: catalog  === -1,
      lastStatus: catalog
    },
    {
      name: "No. Siniestro",
      checked: number === 1,
      reject: number  === -1,
      lastStatus: number
    },
    {
      name: "Fecha de Siniestro",
      checked: date === 1,
      reject: date  === -1,
      lastStatus: date
    },
    {
      name: "Cadenamiento y reporte Inbursa",
      checked: inbursa === 1,
      reject: inbursa === -1,
      lastStatus: inbursa
    }
  ]
}

export default ({id}) => {
  return Vue.$http.get(`/sinisters/affected/commercial-agreements/${id}/`)
    .then(({data}) => Transformer(data))
}


// WEBPACK FOOTER //
// ./src/services/purchase/fetchCommercialAgreements.js